<ng-container [ngSwitch]="iconType">
  <mat-icon *ngSwitchCase="'matIcon_outlined'" [svgIcon]="matIcon"></mat-icon>
  <i *ngSwitchCase="'matIcon'" class="material-icons">{{ matIcon }}</i>
  <div *ngSwitchCase="'logoUrl'" class="business-navbar__icon-container">
    <img class="business_navbar__icon__size" [ngSrc]="logoUrl" width="24" height="24" alt="productIcon" />
  </div>
  <div
    *ngSwitchCase="'generated'"
    class="business-navbar__icon-container"
    [style.background-color]="getIconColorForName()"
  >
    <span *ngIf="!!productName && !logoUrl">
      {{ getAbbreviationForName() }}
    </span>
  </div>
  <div *ngSwitchDefault class="business-navbar__icon__stencil"></div>
</ng-container>
